import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.match";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

export var pathSelector = function pathSelector(state) {
  return state.request.path;
};
export var querySelector = function querySelector(state) {
  return state.request.query;
};
export var querySelectorRaw = function querySelectorRaw(state) {
  var currentFullUrl = state.request.currentFullUrl;

  var _ref = currentFullUrl.match(/\?.*$/) || '',
      _ref2 = _slicedToArray(_ref, 1),
      queryString = _ref2[0];

  return queryString || '';
};
export var fullPathSelector = function fullPathSelector(state) {
  var _state$request = state.request,
      currentFullUrl = _state$request.currentFullUrl,
      hostname = _state$request.hostname;
  return currentFullUrl.replace(new RegExp("^https?://".concat(hostname, "(:\\d+)?/")), '/');
};